import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
  }),
);

export default function UnAuthenticatedPage() {
  const classes = useStyles(baseTheme);

  return (
    <div className={classes.root}>
      UnAuth!
    </div>
  );
}
